import { ButtonEditorState, ScreenEnum, ScreenOrientationEnum } from '../types';
import { getDefaultButtonLayout } from '../constants';

export const buttonEditorState: ButtonEditorState = {
  screen: ScreenEnum.dashboard,
  orientation: ScreenOrientationEnum.landscape,
  landScape: null,
  portrait: null,
  workingLandscape: getDefaultButtonLayout('landscape'),
  workingPortrait: getDefaultButtonLayout('portrait'),
  workingLayoutsSeeded: false,
};
